import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'

import { billingProfileHasValidAddress } from './billing-profile-has-valid-address.ts'
import { billingProfileHasValidContactEmail } from './billing-profile-has-valid-contact-email.ts'

export function billingProfileHasValidContactInfo(
  billingProfile: BillingProfileDomainQueryModel
) {
  return (
    billingProfileHasValidAddress(billingProfile) &&
    billingProfileHasValidContactEmail(billingProfile)
  )
}
